import { render } from "./subadmin-modal.vue?vue&type=template&id=266a8612"
import script from "./subadmin-modal.vue?vue&type=script&lang=js"
export * from "./subadmin-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__